<template>
  <!--
    Selector de rango de fechas basado en flatpickr (ya incluido en el proyecto).
    Mantiene el contrato previo: emite 'change-date' con { start, end } como objetos Date.
  -->
  <flat-pickr
    v-model="dates"
    :config="config"
    class="form-control"
    placeholder="Inicio - Término"
    aria-label="Rango de fechas"
    @on-change="onChange"
  />
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";

export default {
  name: "DatePicker",
  components: { flatPickr },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  emits: ["change-date"],
  data() {
    return {
      dates: [new Date(), new Date()],
      isSyncingFromValue: false,
      config: {
        mode: "range",
        dateFormat: "d/m/Y",
        locale: Spanish,
        defaultDate: [new Date(), new Date()],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.start && newValue.end) {
          const nextDates = [new Date(newValue.start), new Date(newValue.end)];
          if (this.isSameRange(nextDates, this.dates)) return;

          this.isSyncingFromValue = true;
          this.dates = nextDates;
          this.$nextTick(() => {
            this.isSyncingFromValue = false;
          });
        }
      },
    },
  },
  methods: {
    onChange(selectedDates) {
      if (this.isSyncingFromValue) return;
      if (selectedDates.length >= 2) {
        if (this.value && this.value.start && this.value.end) {
          const currentDates = [new Date(this.value.start), new Date(this.value.end)];
          if (this.isSameRange(selectedDates, currentDates)) return;
        }
        this.$emit("change-date", { start: selectedDates[0], end: selectedDates[1] });
      }
    },
    isSameRange(firstRange, secondRange) {
      if (!firstRange || !secondRange || firstRange.length < 2 || secondRange.length < 2) {
        return false;
      }

      return firstRange[0].toDateString() === secondRange[0].toDateString()
        && firstRange[1].toDateString() === secondRange[1].toDateString();
    },
  },
};
</script>
